import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=3181ab85&scoped=true&"
import script from "./page-view.vue?vue&type=script&lang=js&"
export * from "./page-view.vue?vue&type=script&lang=js&"
import style0 from "./page-view.vue?vue&type=style&index=0&id=3181ab85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181ab85",
  null
  
)

export default component.exports